import {convertArrayToObject} from "@Array/convertArrayToObject";

/**
 * Converts object to array, values to strings, maps each members and returns modified object
 * Useful for posting / getting ajax array values
 * @param object
 * @return {object}
 */
export default function stringifyObject(object: object) {
    const array = Object.entries(object)
    return convertArrayToObject(array.map((item) => {
        if (Array.isArray(item[1]) && !!item[1].length) {
            return {[item[0]]: JSON.stringify(item[1])}
        }
        return {[item[0]]: item[1]}
    }))
}